module.exports = __webpack_public_path__ + "img/login-scan.03fc813d.png";